function defaultSerializer(config, prop, value) {
    config[prop] = value;
}
class NodeConfig {
    constructor(self) {
        this._config = {};
        this._renderedConfig = {};
        if (self.parent) {
            self._renderedConfig = Object.assign({}, self.parent.getConfig());
        }
        else {
            self._renderedConfig = {};
        }
        self._config = {};
    }
    updateConfig(propOrObject, value, serializer = defaultSerializer) {
        const config = this._config;
        let configDelta = {};
        if (typeof propOrObject !== 'object') {
            configDelta[propOrObject] = value;
        }
        else if (propOrObject !== null) {
            configDelta = propOrObject;
        }
        Object.keys(configDelta).forEach((prop) => {
            this._updateRenderedConfig(prop, configDelta[prop]);
            serializer(config, prop, configDelta[prop]);
        });
    }
    _updateRenderedConfig(prop, value, serializer = defaultSerializer) {
        const config = this._config;
        const renderedConfig = this._renderedConfig;
        if (config[prop]) {
            return;
        }
        serializer(renderedConfig, prop, value);
        this._children.forEach((child) => {
            child._updateRenderedConfig(prop, value);
        });
    }
    deleteConfig(prop, serializer = defaultSerializer) {
        const config = this._config;
        const renderedConfig = this._renderedConfig;
        let parentPropValue;
        if (this.parent) {
            parentPropValue = this.parent._getRenderedConfig(prop);
        }
        if (config.hasOwnProperty(prop)) {
            delete config[prop];
            if (parentPropValue) {
                serializer(renderedConfig, prop, parentPropValue);
            }
            else {
                delete renderedConfig[prop];
            }
        }
        this._children.forEach((child) => {
            if (parentPropValue) {
                child._updateRenderedConfig(prop, parentPropValue);
            }
            else {
                child._deleteRenderedConfig(prop);
            }
        });
    }
    _deleteRenderedConfig(prop) {
        const config = this._config;
        const renderedConfig = this._renderedConfig;
        if (config.hasOwnProperty(prop)) {
            return;
        }
        delete renderedConfig[prop];
        this._children.forEach((child) => {
            child._deleteRenderedConfig(prop);
        });
    }
    _getRenderedConfig(prop) {
        const renderedConfig = this._renderedConfig;
        return prop ? renderedConfig[prop] : renderedConfig;
    }
    getConfig(prop) {
        return this._getRenderedConfig(prop);
    }
}
export default {
    pluginName: 'config',
    dependencies: ['parent'],
    nodeInit: function () {
        return new NodeConfig(this);
    },
    nodeMethods: NodeConfig.prototype,
};
//# sourceMappingURL=config.js.map